import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  // Login.js-il naam save seidha 'token'-ai vaithu valid-aa nu check seigirom
  const token = localStorage.getItem("token");

  if (!token) {
    // Token illai endral direct-aga /login page-kku thalli vidum
    return <Navigate to="/login" replace />;
  }

  // Token irundhal Layout matrum ungal active app dashboard components render aagum
  return children;
}